import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const ListSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('md:flex-between gap-3 p-3', className);

	// Render
	return (
		<Card size='sm' className={rootClassName}>
			<span className='flex-start-top gap-3 w-full'>
				<CardHeader className='aspect-[1/1] rounded-control shrink-0 w-9'>
					<Skeleton className='leading-[inherit]' />
				</CardHeader>
				<CardContent className='w-full'>
					<CardTitle>
						<Skeleton className='w-1/4' />
					</CardTitle>
					<CardDescription>
						<Skeleton className='w-1/2' />
					</CardDescription>
				</CardContent>
			</span>
			<span className='aspect-[1/1] shrink-0 w-8'>
				<Skeleton />
			</span>
		</Card>
	);
};
export { ListSkeleton };
